import type { TenantConfig } from '@/types/TenantConfig'

const blue = '#00A3E0'

export const nzmm: TenantConfig = {
  logo: 'assets/nzmm/static/logo.png',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: 'black',
    secondaryColor: blue,
    memberLinksColor: blue,
    cartHeaderBackgroundColor: 'black',
    logoHeight: '40px',
    headerHeight: '90px',
    headerBottomBorder: '.0625rem solid hsla(0,0%,74.1%,.75)',
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
    datePicker: {
      focusedDayBackgroundColor: blue,
    },
  },
}
